<template>
  <div class="relative lg:inline-block text-left mt-2 lg:mt-0 ">
    <BaseDropdown
      :options="filterOptions"
      trigger="hover"
      divide-items
      large-items
      class="w-full"
    >
      <div class="relative lg:inline-block text-left w-full">
        <BaseButton
          variant="white-secondary"
          class="group"
          block
        >
          <div
            v-if="$useNewLayout"
            class="mr-1"
          >
            {{ $t('Recurrences') }}:
          </div>
          <i
            v-else
            class="fas fa-repeat mr-2"
          />
          <span
            class="group-hover:text-white"
            :class="{
              'text-primary-500': showRecurrences,
              'text-gray-500': !showRecurrences,
            }"
          >
            {{ showRecurrences ? $t('Yes') : $t('No') }}
          </span>
        </BaseButton>
      </div>
      <template #menu-header>
        <div class="px-4 py-2 bg-gray-50 text-gray-500 rounded-t-md sticky top-0 border-b border-gray-200">
          <span class="text-sm font-medium truncate">
            {{ title || $t('Show recurrences?') }}
          </span>
          <BaseTooltip
            :content="$t('Clicking on any recurrence will open the current active task.')"
          >
            <i class="cursor-pointer text-sm fa-solid fa-circle-question ml-1" />
          </BaseTooltip>
        </div>
      </template>
    </BaseDropdown>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    columns: {
      type: Array,
      default: () => []
    },
    defaultFilter: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showRecurrences: this.defaultFilter || false,
    }
  },
  computed: {
    filterOptions() {
      return [
        {
          label: this.$t('No'),
          action: () => this.setValue(false),
          variant: !this.showRecurrences ? 'active' : ''
        },
        {
          label: this.$t('Yes'),
          action: () => this.setValue(true),
          variant: this.showRecurrences ? 'active' : ''
        }
      ]
    }
  },
  methods: {
    setValue(value) {
      this.showRecurrences = value
      this.$emit('change', this.showRecurrences)
    }
  },
  watch: {
    defaultFilter() {
      this.showRecurrences = this.defaultFilter || false
    }
  }
}
</script>
